export const URL = {
  TermsOfUse: '/terms-of-use',
  PrivacyPolicy: '/privacy-policy',
};
